export default __webpack_public_path__ + "static/media/heart-filled.fc1b1bf9.svg";